import {
  Receipt,
  People,
  ShoppingCart,
  Inventory,
  Warehouse,
  Autorenew,
  LocationOn,
  MapOutlined,
  LocalShipping,
  MoveToInbox,
  Storage,
  Groups,
  Person,
  Route,
  Assignment,
  ShowChart,
} from '@mui/icons-material';
import { Navigation } from '@toolpad/core';

export const navigation: Navigation = [
  {
    segment: 'reception',
    title: 'Receção',
    icon: <MoveToInbox />,
    children: [
      {
        segment: 'suppliers',
        title: 'Fornecedores',
        icon: <People />,
      },
      {
        segment: 'purchase-orders',
        title: 'Encomendas',
        icon: <Receipt />,
      },
      {
        segment: 'reception-processes',
        title: 'Processos de Receção',
        icon: <MoveToInbox />,
      },
    ],
  },
  {
    segment: 'shipping',
    title: 'Expedição',
    icon: <LocalShipping />,
    children: [
      {
        segment: 'customers',
        title: 'Clientes',
        icon: <People />,
      },
      {
        segment: 'circuits',
        title: 'Circuitos',
        icon: <Route />,
      },
      {
        segment: 'sales-orders',
        title: 'Encomendas',
        icon: <ShoppingCart />,
      },
      {
        segment: 'picking-processes',
        title: 'Processos de Expedição',
        icon: <LocalShipping />,
      },
    ],
  },
  {
    segment: 'replenishment',
    title: 'Reposição',
    icon: <Autorenew />,
    children: [
      {
        segment: 'thresholds',
        title: 'Limites',
        icon: <ShowChart />,
      },
      {
        segment: 'orders',
        title: 'Ordens',
        icon: <Assignment />,
      },
    ],
  },
  {
    segment: 'products',
    title: 'Produtos',
    icon: <Inventory />,
    children: [
      {
        segment: 'products',
        title: 'Produtos',
        icon: <Inventory />,
      },
      {
        segment: 'items',
        title: 'Stock',
        icon: <Storage />,
      },
    ],
  },
  {
    segment: 'management',
    title: 'Gestão',
    icon: <Groups />,
    children: [
      {
        segment: 'workers',
        title: 'Operadores',
        icon: <Person />,
      },
      {
        segment: 'teams',
        title: 'Equipas',
        icon: <Groups />,
      },
      {
        segment: 'devices',
        title: 'Dispositivos',
        icon: <Storage />,
      },
    ],
  },
  {
    segment: 'warehouse',
    title: 'Armazém',
    icon: <Warehouse />,
    children: [
      // {
      //   segment: 'warehouses',
      //   title: 'Armazéns',
      //   icon: <Warehouse />,
      // },
      {
        segment: 'locations',
        title: 'Localizações',
        icon: <LocationOn />,
      },
      {
        segment: 'areas',
        title: 'Áreas',
        icon: <MapOutlined />,
      },
      {
        segment: 'asrs-servers',
        title: 'Módulos ASRS',
        icon: <Warehouse />,
      },
    ],
  },
];
